/* ss-card-carousel — Pfeil-Navigation fuer den swipebaren Produktkarten-Bild-Slider
 * (.ss-cardcar / .ss-cardcar__track / .ss-cardcar__slide / .ss-cardcar__arrow--prev|--next).
 *
 * Be Yours hat keine Prestige carousel-prev/next-button-Webkomponenten, daher hier
 * reines Vanilla-JS per Event-Delegation auf document-Ebene: kein globaler State,
 * funktioniert auch fuer nachtraeglich eingefuegte Karten (Quick View, Infinite
 * Scroll, Facet-Re-Render, Design-Mode-Section-Reload) ohne erneute Initialisierung.
 *
 * Mobiles Wischen ist natives CSS-Scroll-Snapping (siehe ss-card-carousel.css) und
 * braucht kein JS.
 */
(function () {
  'use strict';

  function getWrap(el) {
    return el.closest('.ss-cardcar');
  }

  function getTrack(wrap) {
    return wrap ? wrap.querySelector('.ss-cardcar__track') : null;
  }

  function updateArrows(track) {
    if (!track) return;
    var wrap = getWrap(track);
    if (!wrap) return;

    var prev = wrap.querySelector('.ss-cardcar__arrow--prev');
    var next = wrap.querySelector('.ss-cardcar__arrow--next');
    var maxScrollLeft = track.scrollWidth - track.clientWidth;

    if (prev) {
      prev.disabled = track.scrollLeft <= 0;
    }
    if (next) {
      next.disabled = track.scrollLeft >= maxScrollLeft - 1;
    }
  }

  function initTrack(track) {
    updateArrows(track);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var tracks = scope.querySelectorAll('.ss-cardcar__track');
    for (var i = 0; i < tracks.length; i++) {
      initTrack(tracks[i]);
    }
  }

  // Klick auf Pfeil -> um eine Slide-Breite scrollen
  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('.ss-cardcar__arrow');
    if (!arrow || arrow.disabled) return;

    var wrap = getWrap(arrow);
    var track = getTrack(wrap);
    if (!track) return;

    event.preventDefault();

    var slide = track.querySelector('.ss-cardcar__slide');
    var slideWidth = slide ? slide.getBoundingClientRect().width : track.clientWidth;
    var direction = arrow.classList.contains('ss-cardcar__arrow--next') ? 1 : -1;

    track.scrollBy({ left: direction * slideWidth, behavior: 'smooth' });
  });

  // Scroll-Events bubblen nicht, aber ein Capture-Listener auf document faengt sie
  // trotzdem fuer jeden scrollbaren Nachfahren ab (deshalb funktioniert das additiv,
  // auch fuer Tracks, die erst spaeter ins DOM kommen).
  document.addEventListener(
    'scroll',
    function (event) {
      var track = event.target;
      if (!track || !track.classList || !track.classList.contains('ss-cardcar__track')) return;
      updateArrows(track);
    },
    { capture: true, passive: true }
  );

  // Wisch-Hinweis (mobil): Die erste Karte im Produktraster wischt einmal kurz an und
  // springt zurueck, damit klar ist, dass die Bilder swipebar sind. Einmal pro Sitzung,
  // nicht bei reduzierter Bewegung, nicht auf Geraeten mit Maus (dort gibt es Pfeile).
  var HINT_KEY = 'ss-cardcar-hint';

  function hintDone() {
    try { return sessionStorage.getItem(HINT_KEY) === '1'; } catch (e) { return false; }
  }

  function markHint() {
    try { sessionStorage.setItem(HINT_KEY, '1'); } catch (e) {}
  }

  function playHint(track) {
    if (hintDone() || track.scrollLeft > 0) return;
    markHint();
    var distance = Math.round(track.clientWidth * 0.35);
    track.style.scrollSnapType = 'none';
    track.scrollTo({ left: distance, behavior: 'smooth' });
    setTimeout(function () {
      track.scrollTo({ left: 0, behavior: 'smooth' });
      setTimeout(function () { track.style.scrollSnapType = ''; }, 600);
    }, 700);
  }

  function initHint() {
    if (hintDone() || !window.IntersectionObserver || !window.matchMedia) return;
    if (!window.matchMedia('(hover: none) and (max-width: 749px)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var track = document.querySelector('.product-grid .ss-cardcar__track');
    if (!track) return;

    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      setTimeout(function () { playHint(track); }, 600);
    }, { threshold: 0.8 });
    observer.observe(track);
  }

  function ready() {
    initAll(document);
    initHint();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  // Section-Re-Renders (Theme-Editor, Quick-Buy-Refresh, etc.)
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  // Robust gegen nachgeladene Karten (Infinite Scroll, Facet-Filter, Quick View)
  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var addedNodes = mutations[i].addedNodes;
        for (var j = 0; j < addedNodes.length; j++) {
          var node = addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.classList && node.classList.contains('ss-cardcar__track')) {
            initTrack(node);
          } else if (node.querySelectorAll) {
            var nested = node.querySelectorAll('.ss-cardcar__track');
            for (var k = 0; k < nested.length; k++) {
              initTrack(nested[k]);
            }
          }
        }
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
